export * from './settings.component';